export enum FeatureToggle {
  onboarding = 'onboarding',
  launchOnboarding = 'rt_partner_onboarding',
  PartnerOnboardingSignupInProgressRedirect = 'partner_onboarding_signup_in_progress_redirect',
  OnboardingSiteSetup = 'rt_onboarding_site_setup',
}
